import { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import { get, keyBy } from 'lodash';
import personEntityTypesQuery from './data/personEntityTypes.graphql';
export default function usePersonEntityTypes() {
    const queryRes = useQuery(personEntityTypesQuery, {
        fetchPolicy: 'cache-first',
    });
    const personEntityTypes = useMemo(() => get(queryRes, 'data.personEntityTypes', []), [queryRes]);
    const personEntityTypesById = useMemo(() => keyBy(personEntityTypes, 'id'), [
        personEntityTypes,
    ]);
    return {
        personEntityTypes,
        personEntityTypesById,
        error: queryRes.error,
        loading: queryRes.loading,
    };
}
